module.exports = __webpack_public_path__ + "img/ata-logo.104a6408.jpg";